import { FieldGuesser, InputGuesser, ListGuesser, ShowGuesser } from '@api-platform/admin'
import React from 'react'
import {
    Create as BaseCreate,
    Edit as BaseEdit,
    required,
    SaveButton,
    SimpleForm,
    Toolbar,
    useRecordContext,
} from 'react-admin'

const Title = () => {
    const record = useRecordContext()

    return <span>{record ? `${record?.email}` : ''}</span>
}

const EditToolbar = (props) => (
    <Toolbar {...props}>
        <SaveButton />
    </Toolbar>
)

const InputFields = ({ Guesser, ...props }) => (
    <Guesser {...props}>
        <SimpleForm toolbar={<EditToolbar />}>
            <InputGuesser label='Name' source='name' fullWidth isRequired validate={[required()]} />
        </SimpleForm>
    </Guesser>
)

const Fields = ({ Guesser, ...props }) => (
    <Guesser {...props}>
        <FieldGuesser label='Name' source='name' />
    </Guesser>
)

export const Create = (props) => <InputFields Guesser={BaseCreate} title={`CREATE`} {...props} />

export const Edit = (props) => <InputFields Guesser={BaseEdit} title={<Title />} {...props} />

export const Show = (props) => <Fields Guesser={ShowGuesser} title={<Title />} {...props} />

export const List = (props) => <Fields Guesser={ListGuesser} {...props} />

const CRUD = {
    list: List,
    edit: Edit,
    create: Create,
    show: Show,
}

export default CRUD
